import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatCheckboxChange, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MessagesGeneral, MessagesTitles, MessagesStatus, MessagesDates } from '../../../models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import Swal from "sweetalert2";
import * as moment from 'moment';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FiltrosInversionistas } from 'app/models/FiltrosInversionistas';
import { DocumentoNegociableService } from 'app/services/documento-negociable/documento-negociable.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-nuevo-inversion',
  templateUrl: './nuevo-inversion.component.html',
  styleUrls: ['./nuevo-inversion.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class NuevoInversionComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  idProvedor: any;
  idAdquirente: any;
  proveedoresArr: any;
  adquirentesArr: any;
  checkboxStates = {}
  ruc = new FormControl();
  rucAdq = new FormControl();
  filteredProveeedor: Observable<any[]>;
  filteredAdquirente: Observable<any[]>;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  loading: boolean = false;
  DocumentosNegociables: any = [];
  abrirPopUp: boolean = false;
  monedaElement: any;
  datosEnviar: any = [];
  dataFondo: any = [];
  DTOFiltrosInversionistas: FiltrosInversionistas = new FiltrosInversionistas();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns = ['checked', 'Serie', 'Numero', 'RazonSocialProveedor', 'RazonSocialAdquirente', 'VNPP'];
  dataSource: any = [];
  pageSizeOptions = [10, 20, 30, 50, 100, 200];

  constructor(private datepipe: DatePipe, private documentoNegociable: DocumentoNegociableService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,) {
    this.DTOFiltrosInversionistas.FechaIni = this.datepipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosInversionistas.FechaFin = this.datepipe.transform(moment(), 'yyyy-MM-dd');
    this.ObtenerAdquirentesCombo();
    this.ObtenerProveedoresCombo()
  }
  ngOnInit() {
    this.DTOFiltrosInversionistas.Moneda = this.Label_id_soles;
    this.monedaElement = this.Label_id_soles;
    this.ListadoDocInversion();
  }

  tipoMoneda(event) {
    this.DTOFiltrosInversionistas.Moneda = event;
  }
  ListadoDocInversion() {
    this.loading = true;

    if (this.ruc.value == null || this.ruc.value == "") {
      this.idProvedor = "0";
      this.DTOFiltrosInversionistas.IdProv = "0";
    }
    if (this.rucAdq.value == null || this.rucAdq.value == "") {
      this.idAdquirente = "0";
      this.DTOFiltrosInversionistas.IdAdq = "0";
    }

    this.DTOFiltrosInversionistas.FechaIni = this.datepipe.transform(this.DTOFiltrosInversionistas.FechaIni, 'yyyy-MM-dd');
    this.DTOFiltrosInversionistas.FechaFin = this.datepipe.transform(this.DTOFiltrosInversionistas.FechaFin, 'yyyy-MM-dd');
    this.documentoNegociable.ObtenerFacturasFondoInversion(this.DTOFiltrosInversionistas)
      .subscribe(resp => {

        this.DocumentosNegociables = resp

        this.dataSource = new MatTableDataSource(this.DocumentosNegociables);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;

        this.DocumentosNegociables.forEach(item => {
          this.checkboxStates[item.idComprobante] = false
        });

      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })
  }

  obtenerRucRazSocialAdq(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.adquirentesArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idAdquirente = p.idEmpresa;
          this.DTOFiltrosInversionistas.IdAdq = p.idEmpresa;
        }
      }
    }
  }

  obtenerRucRazSocialProv(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProvedor = p.idEmpresa;
          this.DTOFiltrosInversionistas.IdProv = p.idEmpresa;
        }
      }
    }
  }


  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirente = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentesArr.slice()
        )
      );
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerIdProv(termino: string) {
    this.idProvedor = termino;
    this.DTOFiltrosInversionistas.IdProv = termino;
  }


  obtenerIdAdq(termino: string) {
    this.idAdquirente = termino;
    this.DTOFiltrosInversionistas.IdAdq = termino;
  }

  changeCheckBoxesStatus(e: MatCheckboxChange) {
    if (e.checked) {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = true;
      })
    } else {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = false;
      })
    }
  }

  Fondear() {
    this.datosEnviar = [];

    this.DocumentosNegociables.forEach(item => {
      if (this.checkboxStates[item.idComprobante]) {
        this.datosEnviar.push(item)
      }
    });
    if (this.datosEnviar.length == 0) {
      Swal.fire({
        title: "ADVERTENCIA",
        text: "seleccione al menos 1 check",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    this.documentoNegociable.arrayFondo = this.datosEnviar;
    this.abrirPopUp = true;
  }

  CerrarPopUp() {
    this.abrirPopUp = false;
  }


}